<template>
    <div class="wrapper">
        <NavBar />
        <Menu />
        <!-- Spinner Start -->
        <div id="spinner" v-if="halamanloading"
            class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center"
            style="opacity: 0.5;">
            <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <!-- Spinner End -->
        <div class="content-wrapper py-3">
            <div class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-6 wow fadeInDown">
                            <h5>Pengambilan Sampel</h5>
                        </div>
                        <div class="col-sm-6 wow fadeInDown">
                            <ol class="breadcrumb float-sm-right">
                                <li class="breadcrumb-item"><a href="/Dashboard">HOME </a></li>
                                <li class="breadcrumb-item active">Pengambilan Sampel</li>
                            </ol>
                        </div>
                    </div><!-- /.row -->
                </div><!-- /.container-fluid -->
            </div>
            <!-- /.content-header -->
            <div class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-sm-12  wow fadeInDown"
                            v-if="(leveluser == 0) || (leveluser == 1) || (leveluser == 4)">
                            <div class="card collapsed-card">
                                <div class="card-header border-transparent" data-card-widget="collapse"
                                    style="cursor: pointer;">
                                    <label>Import Data Excel</label>
                                    <div class="card-tools">
                                        <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                            <i class="fas fa-plus"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="col-sm-12">
                                        <div class="col-sm-12 text-center">
                                            <a class="hitam">
                                                <button type="button" class="btn btn-success btn-sm text-white lebar2"
                                                    data-toggle="tooltip" data-placement="left"
                                                    title="Unduh master excel.." @click="G_tableCSV('_Sampel_')">
                                                    <i class="fas fa-download"></i> Unduh Master Data Sampel .xlsx
                                                </button>
                                            </a>
                                        </div>
                                        <!--IKON PETA 1-->
                                        <div class="col-sm-12">
                                            <label>Pilih File<small class="text-info"> (*.xlsx)</small>
                                            </label>
                                            <div class="input-group mb-3">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text"><i
                                                            class="far fa-file-image"></i></span>
                                                </div>
                                                <input type="file" class="form-control form-control-sm"
                                                    id="fileToUploadfilenya_excel" name="fileToUploadfilenya_excel"
                                                    placeholder="fileToUpload" style="font-size: smaller;"
                                                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                                    @change="onChange">
                                                <input type="hidden" class="form-control form-control-sm"
                                                    id="filenya_excel" name="filenya_excel" placeholder="File Excel">
                                            </div>
                                        </div>
                                        <div class="col-sm-12">
                                            <label>Opsi</label>
                                            <div class="row">
                                                <div class="col-sm-10">
                                                    <div class="progress">
                                                        <div class="progress-bar" role="progressbar" aria-valuenow="0"
                                                            aria-valuemin="0" aria-valuemax="100" style="width:0%"
                                                            id="persennyafilenya_excel">
                                                            <span id="tulisanpersenfilenya_excel">0%</span>
                                                        </div>
                                                    </div>
                                                    <br>
                                                    <span class="text-success" id="suksesnyafilenya_excel"></span>
                                                </div>
                                                <div class="col-sm-2 text-center" v-if="tempjumlah > 0">
                                                    <button type="button"
                                                        class="btn btn-warning btn-sm lebar text-white"
                                                        @click="uploadsavedata()">
                                                        Simpan ke DB
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <!--IKON PETA 1 END-->
                                        <div class="col-sm-12">
                                            Jumlah Data excel siap Import: {{ tempjumlah }}
                                            <span style="float: right;">Jumlah Data excel Tersimpan di DB: {{
                                                tempjumlahdb
                                                }}</span>
                                            <div class="table-responsive table-wrapper" v-if="tempjumlah > 0">
                                                <table class="table m-0" id="tabeldata2">
                                                    <thead>
                                                        <tr>
                                                            <th>
                                                                Urut
                                                            </th>
                                                            <template v-for="(dataheader, urutheader) in tempheader"
                                                                :key="urutheader">
                                                                <th>
                                                                    {{ dataheader }}
                                                                </th>
                                                            </template>
                                                        </tr>
                                                    </thead>
                                                    <template v-for="(datadata, urutdata) in tempdata" :key="urutdata">
                                                        <tr>
                                                            <td>{{ urutdata + 1 }}</td>
                                                            <td v-for="(isidata, urutisi) in datadata" :key="urutisi">
                                                                {{ isidata }}
                                                            </td>
                                                        </tr>
                                                    </template>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-footer">
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 wow fadeInDown">
                            <div class="card cardputih collapsed-card">
                                <div class="card-header border-transparent" data-card-widget="collapse"
                                    style="cursor: pointer;">
                                    <label>Filter Kolom</label>
                                    <div class="card-tools">
                                        <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                            <i class="fas fa-plus"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="card-body px-3">
                                    <div class="row">
                                        <div class="col-sm-2">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxStatusKegiatan"
                                                    value="optionStatusKegiatan"
                                                    @click="showColumnStatusKegiatan = !showColumnStatusKegiatan">
                                                <label for="customCheckboxStatusKegiatan" class="custom-control-label">
                                                    Status Kegiatan</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-2">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxOuput" value="optionOuput"
                                                    @click="showColumnOuput = !showColumnOuput">
                                                <label for="customCheckboxOuput" class="custom-control-label">
                                                    Ouput</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-2">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxPHOFHO" value="optionPHOFHO"
                                                    @click="showColumnPHOFHO = !showColumnPHOFHO">
                                                <label for="customCheckboxPHOFHO" class="custom-control-label">
                                                    PHP / FHO</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-2">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxTarget" value="optionTarget"
                                                    @click="showColumnTarget = !showColumnTarget">
                                                <label for="customCheckboxTarget" class="custom-control-label">
                                                    Target Fisik</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-2">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxRealisasi" value="optionRealisasi"
                                                    @click="showColumnRealisasi = !showColumnRealisasi">
                                                <label for="customCheckboxRealisasi" class="custom-control-label">
                                                    Realisasi Fisik</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-2">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxDeviasi" value="optionDeviasi"
                                                    @click="showColumnDeviasi = !showColumnDeviasi">
                                                <label for="customCheckboxDeviasi" class="custom-control-label">
                                                    Deviasi Fisik</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-2">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxRealisasiKeuangan"
                                                    value="optionRealisasiKeuangan"
                                                    @click="showColumnRealisasiKeuangan = !showColumnRealisasiKeuangan">
                                                <label for="customCheckboxRealisasiKeuangan"
                                                    class="custom-control-label">
                                                    Realisasi Keu.</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-2">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxProgresKeuangan"
                                                    value="optionProgresKeuangan"
                                                    @click="showColumnProgresKeuangan = !showColumnProgresKeuangan">
                                                <label for="customCheckboxProgresKeuangan" class="custom-control-label">
                                                    Progres Keu.</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-2">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxStatus" value="optionStatus"
                                                    @click="showColumnStatus = !showColumnStatus">
                                                <label for="customCheckboxStatus" class="custom-control-label">
                                                    Status Keu.</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-2">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxPenyedia" value="optionPenyedia"
                                                    @click="showColumnPenyedia = !showColumnPenyedia" checked>
                                                <label for="customCheckboxPenyedia" class="custom-control-label">
                                                    Penyedia</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-2">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxMulai" value="optionMulai"
                                                    @click="showColumnMulai = !showColumnMulai">
                                                <label for="customCheckboxMulai" class="custom-control-label">
                                                    Mulai</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-2">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxSelesai" value="optionSelesai"
                                                    @click="showColumnSelesai = !showColumnSelesai">
                                                <label for="customCheckboxSelesai" class="custom-control-label">
                                                    Selesai</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-2">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxDurasi" value="optionDurasi"
                                                    @click="showColumnDurasi = !showColumnDurasi">
                                                <label for="customCheckboxDurasi" class="custom-control-label">
                                                    Durasi</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-2">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxKontrak" value="optionKontrak"
                                                    @click="showColumnKontrak = !showColumnKontrak">
                                                <label for="customCheckboxKontrak" class="custom-control-label">
                                                    No Kontrak</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-2">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxAdendum" value="optionAdendum"
                                                    @click="showColumnAdendum = !showColumnAdendum">
                                                <label for="customCheckboxAdendum" class="custom-control-label">
                                                    Adendum</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-2">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxNilaiKontrak"
                                                    value="optionNilaiKontrak"
                                                    @click="showColumnNilaiKontrak = !showColumnNilaiKontrak">
                                                <label for="customCheckboxNilaiKontrak" class="custom-control-label">
                                                    Nlai Kontrak</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-2">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxBerjalan" value="optionBerjalan"
                                                    @click="showColumnBerjalan = !showColumnBerjalan">
                                                <label for="customCheckboxBerjalan" class="custom-control-label">
                                                    Durasi Berjalan</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-2">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxTersisa" value="optionTersisa"
                                                    @click="showColumnTersisa = !showColumnTersisa">
                                                <label for="customCheckboxTersisa" class="custom-control-label">
                                                    Durasi Tersisa</label>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 wow fadeInDown">
                            <div class="card cardputih">
                                <div class="card-header border-transparent">
                                    <div class="card-tools">
                                        <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                            <i class="fas fa-minus"></i>
                                        </button>
                                    </div>
                                    <div class="col-sm-4 float-left pb-2">
                                        <label>Pilihan Tahun</label>
                                        <v-select :options="tahundata" :reduce="(label) => label.code" label="label"
                                            v-model="defaultSelectedtahundata" @update:modelValue="ontahundataChange"
                                            style="background-color: #ffffff;"></v-select>
                                    </div>
                                    <div class="col-sm-7 float-left pb-2">
                                        <label>Pencarian Kegiatan</label>
                                        <input type="text" v-model="carikata" class="form-control form-control-sm"
                                            placeholder="Masukkan Kata Kunci Pencarian" @keyup="ambildata()">
                                    </div>
                                    <div class="col-sm-12 float-left pb-2">&nbsp;</div>
                                    <div class="col-sm-12 float-left pb-2 px-3 wow fadeInDown">
                                        Jumlah Data {{ G_numFormat(jumlahdata) }}
                                        <span style="float: right;">
                                            <span>Halaman ke: </span>
                                            <select v-model="halaman" @change="onChangeHalaman($event)">
                                                <option v-for="index in jumlahhalaman" :key="index">
                                                    {{ index }}</option>
                                            </select>
                                            <span> dari </span> {{ jumlahhalaman }}
                                        </span>
                                    </div>
                                    
                                </div>
                                <div class="card-body p-0">
                                    <div class="table-responsive table-wrapper">
                                        <table class="table m-0" id="tabeldata" style="font-size: small;">
                                            <thead>
                                                <tr>
                                                    <th style="width: 50px;" rowspan="4">No</th>
                                                    <th style="width: 100px;" rowspan="4">PIU</th>
                                                    <th style="width: 100px;" rowspan="4">Kegiatan</th>
                                                    <th style="width: 100px;" rowspan="4"
                                                        v-if="showColumnStatusKegiatan">Status<br>Kegiatan</th>
                                                    <th style="width: 50px;" rowspan="4" v-if="showColumnOuput">Ouput
                                                    </th>
                                                    <th style="width: 50px;" rowspan="4" v-if="showColumnPHOFHO">
                                                        Status<br>PHO/FHO</th>
                                                    <th style="width: 50px;" rowspan="4" v-if="showColumnPHOFHO">
                                                        Tanggal<br>PHO/FHO</th>
                                                    <th style="width: 50px;" rowspan="4" v-if="showColumnTarget">
                                                        Target<br>Fisik (%)</th>
                                                    <th style="width: 50px;" rowspan="4" v-if="showColumnRealisasi">
                                                        Realisasi<br>Fisik (%)</th>
                                                    <th style="width: 50px;" rowspan="4" v-if="showColumnDeviasi">
                                                        Deviasi<br>Fisik (%)</th>
                                                    <th style="width: 50px;" rowspan="4"
                                                        v-if="showColumnRealisasiKeuangan">
                                                        Realisasi<br>Keuangan<br>Kumulatif<br>(Rp.)</th>
                                                    <th style="width: 50px;" rowspan="4"
                                                        v-if="showColumnProgresKeuangan">Progres<br>Keuangan (%)</th>
                                                    <th style="width: 50px;" rowspan="4" v-if="showColumnStatus">
                                                        Status<br>Penyerapan<br>Anggaran</th>
                                                    <th style="width: 50px;" rowspan="4" v-if="showColumnPenyedia">
                                                        Penyedia</th>
                                                    <th style="width: 50px;" rowspan="4" v-if="showColumnMulai">Mulai
                                                    </th>
                                                    <th style="width: 50px;" rowspan="4" v-if="showColumnSelesai">
                                                        Selesai</th>
                                                    <th style="width: 50px;" rowspan="4" v-if="showColumnDurasi">
                                                        Durasi<br>(Bulan)</th>
                                                    <th style="width: 50px;" rowspan="4" v-if="showColumnKontrak">Nomor
                                                        Kontrak</th>
                                                    <th style="width: 50px;" rowspan="4" v-if="showColumnAdendum">
                                                        Adendum</th>
                                                    <th style="width: 50px;" rowspan="4" v-if="showColumnNilaiKontrak">
                                                        Nilai Kontrak<br>(Rp.)</th>
                                                    <th style="width: 50px;" rowspan="4" v-if="showColumnBerjalan">
                                                        Waktu<br>Durasi<br>Berjalan<br>(%)</th>
                                                    <th style="width: 50px;" rowspan="4" v-if="showColumnTersisa">
                                                        Waktu<br>Durasi<br>Tersisa<br>(%)</th>
                                                    <th style="width: 50px;" :colspan="colspanheader">
                                                        PENGAMBILAN SAMPEL LINGKUNGAN TAHUN {{ selectedtahundata }}
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <th style="width: 50px;" :colspan="colspan">
                                                        SEMESTER 1
                                                    </th>
                                                    <th style="width: 50px;" :colspan="colspan">
                                                        SEMESTER 2
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <template v-for="(listtahun, uruttahun) in datatahun">
                                                        <th rowspan="3">Tanggal<br>Pengambilan</th>
                                                        <th rowspan="3">Lokasi<br>Pengambilan</th>
                                                        <th colspan="2">Kualitas<br>Udara<br>Ambien</th>
                                                        <th rowspan="3">Lokasi<br>Pengambilan</th>
                                                        <th colspan="2">Tingkat<br>Kebisingan</th>
                                                        <th rowspan="3">Lokasi<br>Pengambilan</th>
                                                        <th colspan="2">Kualitas<br>Air<br>Permukaan</th>
                                                        <th rowspan="3">Lokasi<br>Pengambilan</th>
                                                        <th colspan="2">Kualitas<br>Air<br>Tanah / Bersih</th>
                                                        <th rowspan="3">Lokasi<br>Pengambilan</th>
                                                        <th colspan="2">Biota<br>Air</th>

                                                        <th rowspan="3">Tanggal<br>Pengambilan</th>
                                                        <th rowspan="3">Lokasi<br>Pengambilan</th>
                                                        <th colspan="2">Kualitas<br>Udara<br>Ambien</th>
                                                        <th rowspan="3">Lokasi<br>Pengambilan</th>
                                                        <th colspan="2">Tingkat<br>Kebisingan</th>
                                                        <th rowspan="3">Lokasi<br>Pengambilan</th>
                                                        <th colspan="2">Kualitas<br>Air<br>Permukaan</th>
                                                        <th rowspan="3">Lokasi<br>Pengambilan</th>
                                                        <th colspan="2">Kualitas<br>Air<br>Tanah / Bersih</th>
                                                        <th rowspan="3">Lokasi<br>Pengambilan</th>
                                                        <th colspan="2">Biota<br>Air</th>
                                                    </template>
                                                </tr>
                                                <tr>
                                                    <th>Latitude</th>
                                                    <th>Longitude</th>
                                                    <th>Latitude</th>
                                                    <th>Longitude</th>
                                                    <th>Latitude</th>
                                                    <th>Longitude</th>
                                                    <th>Latitude</th>
                                                    <th>Longitude</th>
                                                    <th>Latitude</th>
                                                    <th>Longitude</th>

                                                    <th>Latitude</th>
                                                    <th>Longitude</th>
                                                    <th>Latitude</th>
                                                    <th>Longitude</th>
                                                    <th>Latitude</th>
                                                    <th>Longitude</th>
                                                    <th>Latitude</th>
                                                    <th>Longitude</th>
                                                    <th>Latitude</th>
                                                    <th>Longitude</th>
                                                </tr>
                                            </thead>
                                            <template v-for="(datalist, urutlist) in datamaster" :key="urutlist">
                                                <tbody>
                                                    <tr>
                                                        <td class="text-center">{{ urutlist + 1 }}</td>
                                                        <td>
                                                            {{ datalist.nama_satker }}
                                                        </td>
                                                        <td>
                                                            {{ datalist.Nama_Kegiatan }}
                                                        </td>
                                                        <td v-if="showColumnStatusKegiatan">
                                                            {{ datalist.Status_pekerjaan }}
                                                        </td>
                                                        <td class="text-center" v-if="showColumnOuput">
                                                            {{ datalist.Komponen }}
                                                        </td>
                                                        <td class="text-center" v-if="showColumnPHOFHO">
                                                            {{ datalist.PHO_FHO }}
                                                        </td>
                                                        <td class="text-center" v-if="showColumnPHOFHO">
                                                            {{ G_formatDateNonWIB(datalist.tanggalPHO_FHO) }}
                                                        </td>
                                                        <td class="text-center" v-if="showColumnTarget">
                                                            {{ G_numKoma(datalist.TARGET) }}
                                                        </td>
                                                        <td class="text-center" v-if="showColumnRealisasi">
                                                            {{ G_numKoma(datalist.PROGRES) }}
                                                        </td>
                                                        <td class="text-center" v-if="showColumnDeviasi">
                                                            {{ G_numKoma(datalist.DEVIASI) }}
                                                        </td>
                                                        <td class="text-right" v-if="showColumnRealisasiKeuangan">
                                                            {{ G_numFormat(datalist.REALISASI_KUMULATIF) }}
                                                        </td>
                                                        <td class="text-center" v-if="showColumnProgresKeuangan">
                                                            {{ G_numKoma(datalist.PROGRESKEUANGAN) }}
                                                        </td>
                                                        <td class="text-center" v-if="showColumnStatus">
                                                            {{ datalist.STATUS_KEU_PROYEK }}
                                                        </td>
                                                        <td class="text-justify" v-if="showColumnPenyedia">
                                                            {{ datalist.KONTRAKTOR }}
                                                        </td>
                                                        <td class="text-center" v-if="showColumnMulai">
                                                            {{ G_formatDateNonWIB(datalist.MULAI) }}
                                                        </td>
                                                        <td class="text-center" v-if="showColumnSelesai">
                                                            {{ G_formatDateNonWIB(datalist.SELESAI) }}
                                                        </td>
                                                        <td class="text-center" v-if="showColumnDurasi">
                                                            {{ G_numKoma(datalist.BULAN) }}
                                                        </td>
                                                        <td class="text-justify" v-if="showColumnKontrak">
                                                            {{ datalist.NOKONTRAK }}
                                                        </td>
                                                        <td class="text-center" v-if="showColumnAdendum">
                                                            {{ datalist.ADENDUM }}
                                                        </td>
                                                        <td class="text-right" v-if="showColumnNilaiKontrak">
                                                            {{ G_numFormat(datalist.NILAIKONTRAK) }}
                                                        </td>
                                                        <td class="text-center" v-if="showColumnBerjalan">
                                                            {{ G_numKoma(datalist.DURASI) }}
                                                        </td>
                                                        <td class="text-center" v-if="showColumnTersisa">
                                                            {{ G_numKoma(datalist.DURASITERSISA) }}
                                                        </td>
                                                        <template
                                                            v-for="(listlaporan, urutlaporan) in datalist.datasampel"
                                                            :key="urutlaporan">
                                                            <td class="text-right">
                                                                {{ G_formatDateNonWIB(listlaporan.TanggalPengambilan) }}
                                                            </td>
                                                            <td class="text-right">
                                                                {{ listlaporan.lokasi_udara }}
                                                            </td>
                                                            <td class="text-right">
                                                                {{ listlaporan.latitude_udara }}
                                                            </td>
                                                            <td class="text-right">
                                                                {{ listlaporan.longitude_udara }}
                                                            </td>
                                                            <td class="text-right">
                                                                {{ listlaporan.lokasi_kebisingan }}
                                                            </td>
                                                            <td class="text-right">
                                                                {{ listlaporan.latitude_kebisingan }}
                                                            </td>
                                                            <td class="text-right">
                                                                {{ listlaporan.longitude_kebisingan }}
                                                            </td>
                                                            <td class="text-right">
                                                                {{ listlaporan.lokasi_airpermukaan }}
                                                            </td>
                                                            <td class="text-right">
                                                                {{ listlaporan.latitude_airpermukaan }}
                                                            </td>
                                                            <td class="text-right">
                                                                {{ listlaporan.longitude_airpermukaan }}
                                                            </td>
                                                            <td class="text-right">
                                                                {{ listlaporan.lokasi_airtanah }}
                                                            </td>
                                                            <td class="text-right">
                                                                {{ listlaporan.latitude_airtanah }}
                                                            </td>
                                                            <td class="text-right">
                                                                {{ listlaporan.longitude_airtanah }}
                                                            </td>
                                                            <td class="text-right">
                                                                {{ listlaporan.lokasi_biotaair }}
                                                            </td>
                                                            <td class="text-right">
                                                                {{ listlaporan.latitude_biotaair }}
                                                            </td>
                                                            <td class="text-right">
                                                                {{ listlaporan.longitude_biotaair }}
                                                            </td>

                                                            <td class="text-right">
                                                                {{ G_formatDateNonWIB(listlaporan.TanggalPengambilan2)
                                                                }}
                                                            </td>
                                                            <td class="text-right">
                                                                {{ listlaporan.lokasi_udara2 }}
                                                            </td>
                                                            <td class="text-right">
                                                                {{ listlaporan.latitude_udara2 }}
                                                            </td>
                                                            <td class="text-right">
                                                                {{ listlaporan.longitude_udara2 }}
                                                            </td>
                                                            <td class="text-right">
                                                                {{ listlaporan.lokasi_kebisingan2 }}
                                                            </td>
                                                            <td class="text-right">
                                                                {{ listlaporan.latitude_kebisingan2 }}
                                                            </td>
                                                            <td class="text-right">
                                                                {{ listlaporan.longitude_kebisingan2 }}
                                                            </td>
                                                            <td class="text-right">
                                                                {{ listlaporan.lokasi_airpermukaan2 }}
                                                            </td>
                                                            <td class="text-right">
                                                                {{ listlaporan.latitude_airpermukaan2 }}
                                                            </td>
                                                            <td class="text-right">
                                                                {{ listlaporan.longitude_airpermukaan2 }}
                                                            </td>
                                                            <td class="text-right">
                                                                {{ listlaporan.lokasi_airtanah2 }}
                                                            </td>
                                                            <td class="text-right">
                                                                {{ listlaporan.latitude_airtanah2 }}
                                                            </td>
                                                            <td class="text-right">
                                                                {{ listlaporan.longitude_airtanah2 }}
                                                            </td>
                                                            <td class="text-right">
                                                                {{ listlaporan.lokasi_biotaair2 }}
                                                            </td>
                                                            <td class="text-right">
                                                                {{ listlaporan.latitude_biotaair2 }}
                                                            </td>
                                                            <td class="text-right">
                                                                {{ listlaporan.longitude_biotaair2 }}
                                                            </td>
                                                        </template>
                                                    </tr>
                                                </tbody>
                                            </template>
                                            <tbody v-if="(datapesan == 'data kosong')">
                                                <tr>
                                                    Data masih kosong
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div class="card-footer p-3">

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>
import $ from 'jquery';
import axios from 'axios';
import vSelect from 'vue-select';
import swal from 'sweetalert2';
import xlsx from 'xlsx/dist/xlsx.full.min';
import readXlsxFile from 'read-excel-file';
import CryptoJS from 'crypto-js';
import Footer from "../../componen/Footer.vue";
import NavBar from "../../componen/NavBar.vue";
import Menu from "../../componen/Menu.vue";

import VueApexCharts from "vue3-apexcharts";
window.Apex.chart = { fontFamily: "Poppins-SemiBold, Arial, sans-serif" };
export default {
    components: {
        Footer, NavBar, Menu, vSelect, swal
    },
    data() {
        return {
            halamanloading: true,
            iduser: JSON.parse(localStorage.getItem("usistem")),
            leveluser: JSON.parse(localStorage.getItem("lsistem")),
            namauser: JSON.parse(localStorage.getItem("nmusistem")),
            datapesan: '',
            datamaster: [],
            carikata: '',
            colspanheader: 0,
            colspan: 0,
            datatahun: [],
            showColumnStatusKegiatan: false,
            showColumnOuput: false,
            showColumnPHOFHO: false,
            showColumnTarget: false,
            showColumnRealisasi: false,
            showColumnDeviasi: false,
            showColumnRealisasiKeuangan: false,
            showColumnProgresKeuangan: false,
            showColumnStatus: false,
            showColumnPenyedia: true,
            showColumnMulai: false,
            showColumnSelesai: false,
            showColumnDurasi: false,
            showColumnKontrak: false,
            showColumnNilaiKontrak: false,
            showColumnAdendum: false,
            showColumnBerjalan: false,
            showColumnTersisa: false,
            tahundata: [],
            datatahundata: [],
            defaultSelectedtahundata: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            },
            selectedtahundata: 0,
            project_id: process.env.VUE_APP_PROJECT_ID,
            tempexcel: [],
            ekportexcel: [],
            jumlahdata: 0,
            jumlahhalaman: 0,
            mulai: 0,
            halaman: 1,
        }
    },
    computed: {
        filteredKataData() {
            const filteredWorkers = this.carikata === ""
                ? this.datamaster
                : this.datamaster.filter(wo => Object.values(wo).join("").toLowerCase().indexOf(this.carikata.toLowerCase()) !== -1);
            return filteredWorkers;
        },
        JumlahfilteredKataData() {
            var jumlah = 0;
            try {
                if (this.filteredKataData === undefined) {
                    jumlah = 0;
                } else {
                    jumlah = this.filteredKataData.length;
                }
            }
            catch {
                jumlah = 0;
            }
            return jumlah;
        },
    },
    methods: {
        async G_tableCSV(namefile) {
            this.ekportexcel = [];
            this.halamanloading = true;
            this.halamanloading = true;
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var random = Math.random();
            await mainAPI.get("parastapainnovationmonev-AllSampel?random=" + random + "&project_id=" + this.project_id + "&nama=" + this.carikata).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.tempexcel = [];
                        this.tempexcel = Response.data.content.data;
                        for (let i = 0; i < this.tempexcel.length; i++) {
                            this.ekportexcel.push({
                                "No": this.tempexcel[i].id_kegiatan,
                                "PIU": this.tempexcel[i].nama_satker,
                                "Nama Kegiatan": this.tempexcel[i].Nama_Kegiatan,
                                "KONTRAKTOR / PENYEDIA": this.tempexcel[i].KONTRAKTOR,
                                "Tahun Pengambilan": this.tempexcel[i].datasampel[0].Tahun,
                                "Tanggal Pengambilan Semester 1": this.tempexcel[i].datasampel[0].TanggalPengambilan,
                                "Lokasi Pengambilan Kualitas Udara Ambien Semester 1": this.tempexcel[i].datasampel[0].lokasi_udara,
                                "Latitude Pengambilan Kualitas Udara Ambien Semester 1": this.tempexcel[i].datasampel[0].latitude_udara,
                                "Longitude Pengambilan Kualitas Udara Ambien Semester 1": this.tempexcel[i].datasampel[0].longitude_udara,
                                "Lokasi Pengambilan Tingkat Kebisingan Semester 1": this.tempexcel[i].datasampel[0].lokasi_kebisingan,
                                "Latitude Pengambilan Tingkat Kebisingan Semester 1": this.tempexcel[i].datasampel[0].latitude_kebisingan,
                                "Longitude Pengambilan Tingkat Kebisingan Semester 1": this.tempexcel[i].datasampel[0].longitude_kebisingan,
                                "Lokasi Pengambilan Kualitas Air Permukaan Semester 1": this.tempexcel[i].datasampel[0].lokasi_airpermukaan,
                                "Latitude Pengambilan Kualitas Air Permukaan Semester 1": this.tempexcel[i].datasampel[0].latitude_airpermukaan,
                                "Longitude Pengambilan Kualitas Air Permukaan Semester 1": this.tempexcel[i].datasampel[0].longitude_airpermukaan,
                                "Lokasi Pengambilan Kualitas Air Tanah / Bersih Semester 1": this.tempexcel[i].datasampel[0].lokasi_airtanah,
                                "Latitude Pengambilan Kualitas Air Tanah / Bersih Semester 1": this.tempexcel[i].datasampel[0].latitude_airtanah,
                                "Longitude Pengambilan Kualitas Air Tanah / Bersih Semester 1": this.tempexcel[i].datasampel[0].longitude_airtanah,
                                "Lokasi Pengambilan Biota Air Semester 1": this.tempexcel[i].datasampel[0].lokasi_biotaair,
                                "Latitude Pengambilan Biota Air Semester 1": this.tempexcel[i].datasampel[0].latitude_biotaair,
                                "Longitude Pengambilan Biota Air Semester 1": this.tempexcel[i].datasampel[0].longitude_biotaair,

                                "Tanggal Pengambilan Semester 2": this.tempexcel[i].datasampel[0].TanggalPengambilan2,
                                "Lokasi Pengambilan Kualitas Udara Ambien Semester 2": this.tempexcel[i].datasampel[0].lokasi_udara2,
                                "Latitude Pengambilan Kualitas Udara Ambien Semester 2": this.tempexcel[i].datasampel[0].latitude_udara2,
                                "Longitude Pengambilan Kualitas Udara Ambien Semester 2": this.tempexcel[i].datasampel[0].longitude_udara2,
                                "Lokasi Pengambilan Tingkat Kebisingan Semester 2": this.tempexcel[i].datasampel[0].lokasi_kebisingan2,
                                "Latitude Pengambilan Tingkat Kebisingan Semester 2": this.tempexcel[i].datasampel[0].latitude_kebisingan2,
                                "Longitude Pengambilan Tingkat Kebisingan Semester 2": this.tempexcel[i].datasampel[0].longitude_kebisingan2,
                                "Lokasi Pengambilan Kualitas Air Permukaan Semester 2": this.tempexcel[i].datasampel[0].lokasi_airpermukaan2,
                                "Latitude Pengambilan Kualitas Air Permukaan Semester 2": this.tempexcel[i].datasampel[0].latitude_airpermukaan2,
                                "Longitude Pengambilan Kualitas Air Permukaan Semester 2": this.tempexcel[i].datasampel[0].longitude_airpermukaan2,
                                "Lokasi Pengambilan Kualitas Air Tanah / Bersih Semester 2": this.tempexcel[i].datasampel[0].lokasi_airtanah2,
                                "Latitude Pengambilan Kualitas Air Tanah / Bersih Semester 2": this.tempexcel[i].datasampel[0].latitude_airtanah2,
                                "Longitude Pengambilan Kualitas Air Tanah / Bersih Semester 2": this.tempexcel[i].datasampel[0].longitude_airtanah2,
                                "Lokasi Pengambilan Biota Air Semester 2": this.tempexcel[i].datasampel[0].lokasi_biotaair2,
                                "Latitude Pengambilan Biota Air Semester 2": this.tempexcel[i].datasampel[0].latitude_biotaair2,
                                "Longitude Pengambilan Biota Air Semester 2": this.tempexcel[i].datasampel[0].longitude_biotaair2,
                            });
                        }
                        function formatColumn(worksheet, col, fmt) {
                            const range = XLSX.utils.decode_range(worksheet['!ref'])
                            // note: range.s.r + 1 skips the header row
                            for (let row = range.s.r + 1; row <= range.e.r; ++row) {
                                const ref = XLSX.utils.encode_cell({ r: row, c: col })
                                if (worksheet[ref] && worksheet[ref].t === 'n') {
                                    worksheet[ref].z = fmt
                                }
                            }
                        }
                        const currency = '0.00';
                        const XLSX = xlsx;
                        const workbook = XLSX.utils.book_new();
                        const worksheet = XLSX.utils.json_to_sheet(this.ekportexcel);

                        // ARRAY NUMBER SILAHKAN MASUKKAN NOMOR KOLOM
                        for (let col of []) {
                            formatColumn(worksheet, col, currency)
                        }
                        XLSX.utils.book_append_sheet(workbook, worksheet, "Sampel");
                        XLSX.writeFile(workbook, this.G_formatDate(Date(), 'd-M-Y') + namefile + ".xlsx");
                        this.halamanloading = false;
                    }
                    else {
                        this.tempexcel = [];
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                this.ClearlocalStorage();
                this.halamanloading = false;
            });
            //console.log(this.datamaster);
            //return false;
        },
        onChange(event) {
            this.tempjumlahdb = 0;
            try {
                if (event.target.files[0]['type'] == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
                    this.file = event.target.files ? event.target.files[0] : null;
                    if (this.file) {
                        this.tempheader = [];
                        this.tempdata = [];
                        readXlsxFile(this.file).then((rows) => {
                            // `rows` is an array of rows
                            // each row being an array of cells.
                            //alert(rows.length);
                            this.halamanloading = true;
                            this.tempjumlah = rows.length - 1;
                            //alert(this.tempjumlah);
                            for (let i = 0; i < rows.length; i++) {
                                this.halamanloading = true;
                                if (i == 0) {
                                    var varheader = rows[i];
                                    for (let x = 0; x < varheader.length; x++) {
                                        this.tempheader.push(varheader[x]);
                                    }
                                }
                                else {
                                    this.tempdata.push(rows[i]);
                                }
                                document.getElementById('persennyafilenya_excel').style.width = Math.round((i / (rows.length - 1)) * 100) + "%";
                                document.getElementById('tulisanpersenfilenya_excel').innerHTML = Math.round((i / (rows.length - 1)) * 100) + "%";
                            }
                            //alert(JSON.stringify(this.tempheader));
                            //console.log(this.tempdata);
                            this.halamanloading = false;
                        })
                    }
                }
                else {
                    swal.fire('Peringatan', 'File tidak sesuai format', 'error');
                    return false;
                }
            } catch (error) {

            }

        },
        async uploadsavedata() {
            this.tempjumlahdb = 0;
            var tempheader = this.tempheader;
            //console.log(JSON.stringify(this.tempdata));
            //alert(this.tempdata.length);
            //return false;
            var temparraydata = ''
            for (let i = 0; i < this.tempdata.length; i++) {
                var data = "";
                for (let x = 0; x < this.tempdata[i].length; x++) {
                    if (x == 0) {
                        data = this.tempdata[i][x];
                    }
                    else {
                        data = data + '|' + this.tempdata[i][x];
                    }
                }
                if (i == 0) {
                    temparraydata = temparraydata + data;
                }
                else {
                    temparraydata = temparraydata + '|+|' + data;
                }
            }
            //console.log(JSON.stringify(tempheader));
            //console.log(temparraydata);
            //return false;
            var fd = new FormData();
            fd.append("tempheader", tempheader);
            fd.append("data", temparraydata);
            fd.append("project_id", this.project_id);
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            this.halamanloading = true;
            await mainAPI.post("parastapainnovation_excelSampel-SaveSampel", fd).then(
                Response => {
                    if (Response.data.response == 'error') {
                        this.halamanloading = false;
                        swal.fire('Peringatan', Response.data.message, 'error');
                    }
                    else {
                        this.halamanloading = false;
                        swal.fire('Informasi', 'Data telah diimport..', 'success').then(function () {
                            window.location.replace("/Sampel");
                        });

                    }
                }
            ).catch(function (error) {
                this.halamanloading = false;
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: error
                });
            }
            )
            //alert(tempheader);
            //alert(acuan);
            //alert(data);
        },
        getOtentifikasi() {
            var time = Date.parse(localStorage.getItem("tsistem"));
            var timeakhir = time + (3 * 60 * 60 * 1000);
            var timesekarang = Date.parse(new Date());
            if (timesekarang > timeakhir) {
                this.ClearlocalStorage();
            }
        },
        ontahundataChange(a) {
            try {
                this.selectedtahundata = this.tahundata[a].tag;
            }
            catch (err) {
                return;
            }
            this.ambildatatahun();
        },
        onChangeHalaman(event) {
            this.pindahhalaman(event.target.value);
        },
        async pindahhalaman(halamannya) {
            this.halamanloading = true;
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var random = Math.random();
            await mainAPI.get("parastapainnovationmonev-GetSampel?random=" + random + "&project_id=" + this.project_id + "&halaman=" + halamannya + "&nama=" + this.carikata).then(
                Response => {
                    this.datapesan = Response.data.message;
                    this.colspan = 0;
                    this.datatahun = [];
                    this.colspan = 16;
                    this.colspanheader = 16 * 2;
                    this.datatahun = Response.data.tahun;
                    this.datatahundata = [];
                    this.tahundata = [];
                    this.datatahundata = Response.data.tahunku;
                    this.datatahundata.forEach((item) => {
                        this.tahundata.push({
                            label: item,
                            code: this.datatahundata.indexOf(item),
                            tag: item,
                        });
                        this.defaultSelectedtahundata = {
                            code: this.datatahundata.indexOf(item),
                            label: item,
                            tag: item,
                        };
                        this.selectedtahundata = item;
                    });
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datamaster = [];
                        this.datamaster = Response.data.content.data;
                        this.jumlahdata = Response.data.content.jumlahdata;
                        this.jumlahhalaman = Response.data.content.jumlahhalaman;
                        this.mulai = Response.data.content.mulai;
                        if (this.mulai == 0) {
                            this.halaman = 1;
                        }
                        else {
                            this.halaman = (this.mulai / 20) + 1;
                        }
                    }
                    else {
                        this.jumlahdata = 0;
                        this.jumlahhalaman = 0;
                        this.mulai = 0;
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                //console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
                this.jumlahdata = 0;
                this.jumlahhalaman = 0;
                this.mulai = 0;
            });
        },
        async ambildata() {
            this.halamanloading = true;
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var random = Math.random();
            await mainAPI.get("parastapainnovationmonev-GetSampel?random=" + random + "&project_id=" + this.project_id + "&nama=" + this.carikata).then(
                Response => {
                    this.datapesan = Response.data.message;
                    this.colspan = 0;
                    this.datatahun = [];
                    this.colspan = 16;
                    this.colspanheader = 16 * 2;
                    this.datatahun = Response.data.tahun;
                    this.datatahundata = [];
                    this.tahundata = [];
                    this.datatahundata = Response.data.tahunku;
                    this.datatahundata.forEach((item) => {
                        this.tahundata.push({
                            label: item,
                            code: this.datatahundata.indexOf(item),
                            tag: item,
                        });
                        this.defaultSelectedtahundata = {
                            code: this.datatahundata.indexOf(item),
                            label: item,
                            tag: item,
                        };
                        this.selectedtahundata = item;
                    });
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datamaster = [];
                        this.datamaster = Response.data.content.data;
                        this.jumlahdata = Response.data.content.jumlahdata;
                        this.jumlahhalaman = Response.data.content.jumlahhalaman;
                        this.mulai = Response.data.content.mulai;
                        if (this.mulai == 0) {
                            this.halaman = 1;
                        }
                        else {
                            this.halaman = (this.mulai / 20) + 1;
                        }
                    }
                    else {
                        this.jumlahdata = 0;
                        this.jumlahhalaman = 0;
                        this.mulai = 0;
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                //console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
                this.jumlahdata = 0;
                this.jumlahhalaman = 0;
                this.mulai = 0;
            });
        },
        async ambildatatahun() {
            //alert(this.selectedtahundata);
            this.halamanloading = true;
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var random = Math.random();
            await mainAPI.get("parastapainnovationmonev-GetSampel?random=" + random + "&pilihantahun=" + this.selectedtahundata + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    this.colspan = 0;
                    this.datatahun = [];
                    this.colspan = 16;
                    this.colspanheader = 16 * 2;
                    this.datatahun = Response.data.tahun;

                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datamaster = [];
                        this.datamaster = Response.data.content.data;
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                //console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });
        },
    },
    mounted() {
        this.getOtentifikasi();
        this.ambildata();
    }
}
</script>
<style></style>